import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from '../assets/logo.jpeg';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="nav-logo" onClick={close}>
        <img src={logo} alt="CSR Financial Solutions" className="nav-logo-img" />
        <div className="nav-logo-text">
          <span className="t1">CSR's Financial Solutions</span>
          <span className="t2">BPO · KPO · Debt Management</span>
        </div>
      </Link>

      <div className={`nav-links ${open ? 'open' : ''}`}>
        {[
          ['/', 'Home'],
          ['/services', 'Services'],
          ['/about', 'About'],
          ['/blog', 'Blog'],
          ['/contact', 'Contact'],
        ].map(([path, label]) => (
          <NavLink
            key={path}
            to={path}
            end={path === '/'}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={close}
          >
            {label}
          </NavLink>
        ))}
        <Link to="/contact" className="nav-cta" onClick={close}>
          <i className="fas fa-arrow-right"></i> Get Started
        </Link>
      </div>

      <button
        className={`hamburger ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
        aria-label="Menu"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}
